import React from 'react';
import CpsPage from './CpsPage';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { useGetUserPermissions } from '@cs-cms/state-management';
import CpsLoader from '../common/CpsLoader';
import { SettingsContent } from '../settings/SettingsContent';
import { SettingsNavigation } from '../settings/SettingsNavigation';
import TopBar from '../topBar/TopBar';

export const ItAdminSettingsPage: React.FC = () => {
  const { data: permissions } = useGetUserPermissions();

  return (
    <CpsPage className="settingsPage">
      <TopBar />
      {!permissions ? (
        <CpsLoader />
      ) : (
        <>
          <Tooltip anchorElement="target" position="top">
            <SettingsNavigation />
            <SettingsContent />
          </Tooltip>
        </>
      )}
    </CpsPage>
  );
};

export default ItAdminSettingsPage;
